import { Link } from "react-router-dom";
import { animeList } from "@/mocks/anime";

export default function GuomanFeature() {
  const guoman = animeList.filter((a) => a.region === "国漫").slice(0, 3);

  return (
    <section className="relative overflow-hidden bg-foreground-950 py-14 md:py-20">
      <div
        className="absolute inset-0 bg-cover bg-center opacity-25"
        style={{
          backgroundImage:
            "url(https://readdy.ai/api/search-image?query=Stylized%20chinese%20wuxia%20anime%20landscape%20with%20ink%20wash%20mountains%20and%20vermilion%20accents%2C%20gold%20clouds%2C%20elegant%20oriental%20atmosphere%2C%20dark%20moody%20background%20suitable%20for%20text%20overlay&width=1600&height=800&seq=guoman-2026-v1&orientation=landscape)",
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950 via-foreground-950/80 to-foreground-950/60"></div>

      <div className="relative mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:items-center">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-500/90 px-4 py-1.5 text-sm font-medium text-foreground-950">
              <i className="ri-vip-diamond-line"></i>
              国漫专区
            </span>
            <h2 className="mt-4 font-heading text-2xl text-background-50 md:text-4xl">
              东方美学 · 本土原创崛起
            </h2>
            <p className="mt-4 max-w-lg text-sm leading-relaxed text-background-50/80 md:text-base">
              从武侠江湖到山海志怪，国漫用独有的东方审美与热血叙事征服观众。
              在动漫网国漫专区，发现每一部值得骄傲的本土原创动画。
            </p>
            <Link
              to="/categories?cat=guoman"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-6 py-3 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-400"
            >
              探索国漫专区
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
            {guoman.map((anime) => (
              <Link
                key={anime.id}
                to={`/article/${anime.id}`}
                className="group block overflow-hidden rounded-lg border border-background-50/10 bg-background-50/5 backdrop-blur"
              >
                <div className="aspect-[3/4] w-full overflow-hidden">
                  <img
                    src={anime.cover}
                    alt={`${anime.title} 国漫封面`}
                    title={`${anime.title} 国漫`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
                <div className="p-3">
                  <h3 className="truncate font-heading text-base text-background-50">{anime.title}</h3>
                  <p className="mt-1 text-xs text-background-50/70">
                    {anime.status} · {anime.rating.toFixed(1)} 分
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}